import { IGroup } from 'types/group.types'
import { RoomData } from 'types/rooms.types'

const notificationSounds = {
  relax: '/notification-1.mp3',
  makeItPossible: '/notification-2.mp3',
}

export const subscribeToPushService = async () => {
  try {
    const registration = await navigator.serviceWorker.ready
    const existingSubscription = await registration.pushManager?.getSubscription()
    // Unsubscribe first if there is already an existing subscription.
    if (existingSubscription) {
      await existingSubscription.unsubscribe()
    }
    console.log('Subscribed to push service...')
  } catch (error) {
    console.log('Error while subscribing to push service...', error)
  }
}

export const unsubscribeFromPushService = async () => {
  try {
    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager?.getSubscription()
    if (!subscription) {
      return console.log('There is no subscription exists...')
    }
    const isUnsubbed = await subscription.unsubscribe()
    if (!isUnsubbed) {
      return console.error('Error occurred while unsubscribing from push service...')
    }
 
  } catch (error) {
    console.error('Error occurred while unsubscribing from push service...', error)
  }
}

export const playNotificationSound = () => {
  const audio = new Audio(notificationSounds.makeItPossible)
  audio.volume = 0.1
  audio.play()
}

export const getNotificationBadgeForTeams = (groups: IGroup[]) => {
  return groups.some((group) => group?.channels?.some((channel) => channel?.notificationCount))
}

export const getNotificationBadgeForMessages = (rooms: RoomData) => {
  return rooms.some((room) => room?.notificationCount ?? 0)
}
